import ErrorTypes from "../../enums/errorTypes";
import { ActionTypes } from "../actionTypes";
import { actionCreator, AppAction } from "../appAction";

export const setError = actionCreator<ActionTypes.SET_ERROR, ErrorTypes>(ActionTypes.SET_ERROR);
export const resetError = actionCreator<ActionTypes.RESET_ERROR, ErrorTypes>(ActionTypes.RESET_ERROR);

export function setAsError(error: ErrorTypes): AppAction {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return dispatch => {
    dispatch(setError(error));
  };
}

export function resetAsError(error: ErrorTypes): AppAction {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return dispatch => {
    dispatch(resetError(error));
  };
}
